/**
 * Bordered panel chrome shared by the sales-compare mismatch filter and
 * the product sibling switcher. Wraps a card grid (or any children)
 * with the standard panel border, padding, and bottom margin so the two
 * features stay visually aligned above the exception table.
 */
import React from 'react'
import { Paper } from '@mui/material'

interface IssuePanelProps {
  children: React.ReactNode
}

const IssuePanel: React.FC<IssuePanelProps> = ({ children }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        mb: 1.5,
        p: 2,
        borderRadius: 1.5,
        borderColor: 'rgba(0, 0, 0, 0.08)',
        bgcolor: 'background.paper',
      }}
    >
      {children}
    </Paper>
  )
}

export default IssuePanel
